export const taskList = {
	group: "block list",
	content: "taskItem+",
	attrs: {},
};
